import { render, staticRenderFns } from "./Habilitacao.vue?vue&type=template&id=6a47a279"
import script from "./Habilitacao.vue?vue&type=script&lang=js"
export * from "./Habilitacao.vue?vue&type=script&lang=js"
import style0 from "./Habilitacao.vue?vue&type=style&index=0&id=6a47a279&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports